import React, { useContext } from 'react';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter, commonActionHeader } from '../../constants/StyleConstants';
import SelectAcerBrag from '../../components/SelectAcerBrag';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import { Fragment } from 'react';
import useEmployeesAdministrationPresenter from './EmployeesAdministrationPresenter';
import EmployeeGrid from './EmployeesAdministrationGrid';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import { LoginContext } from '../../contexts/LoginContext';

const useStyles = makeStyles(theme => {
  return {
    ...commonFilter,
    ...commonActionHeader(theme),
  };
});

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isAdmin } = useContext(LoginContext);
  const { name, setName, email, setEmail, status, setStatus, validateAndSearch, cleanFilters, selectedSupplier, setSelectedSupplier } = filtersProps;

  return (
    <div className={classes.filters}>
      {isAdmin && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <TextField margin="dense" id="emailEmployee" style={{ width: 200 }} label="Correo" onChange={e => setEmail(e.target.value)} value={email} />
      <TextField
        margin="dense"
        id="razonSocialNombreYApellido"
        style={{ width: 200 }}
        label="Nombre"
        onChange={e => setName(e.target.value)}
        value={name}
      />
      <SelectAcerBrag
        variableWidth
        rows={[
          { id: 'true', name: 'Activo' },
          { id: 'false', name: 'Inactivo' },
        ]}
        value={status}
        setValue={setStatus}
        style={{ marginBottom: 4 }}
        selectTitle="Estado"
      />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const EmployeesAdministration = () => {
  const { firstLoad, rows, loading, reloadGrid, gridFunctions, isAdmin, ...filtersProps } = useEmployeesAdministrationPresenter();
  
  return (
    <Fragment>
      <ViewPortGridWrapper>
        <Filters filtersProps={filtersProps} />
        <DefaultUnrederedGridMessage render={!firstLoad}>
          <EmployeeGrid data={rows} loading={loading} reloadGrid={reloadGrid} {...gridFunctions} isAdmin={isAdmin}/>
        </DefaultUnrederedGridMessage>
      </ViewPortGridWrapper>
    </Fragment>
  );
};
export default EmployeesAdministration;
